module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/a8d49fba99afaf9b7d7627a1802e349b.png";